<!-- src/app/meter/components/meter-list/meter-alerts/meter-alerts.component.html -->

<div class="alerts-container">
    <div class="filter-bar">
        <mat-form-field appearance="outline" class="filter-field-wide">
            <mat-label>{{ 'meter.manage.filter_alert_type' | translate }}</mat-label>
            <mat-select multiple [value]="selectedAlertTypes" (selectionChange)="onAlertTypeChange($event.value)">
                <mat-option *ngFor="let type of alertTypeOptions" [value]="type">{{ type }}</mat-option>
            </mat-select>
        </mat-form-field>

        <label class="resolved-toggle">
            <input type="checkbox" [checked]="showResolved" (change)="onResolvedToggle()">
            {{ 'meter.manage.filter_resolved' | translate }}
        </label>
    </div>

    <div class="table-container">
        <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="40" class="spinner"></mat-progress-spinner>

        <table mat-table [dataSource]="alerts" *ngIf="!loading">
            <ng-container matColumnDef="nodeId">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_meter_id' | translate }}</th>
                <td mat-cell *matCellDef="let item">{{ item.nodeId }}</td>
            </ng-container>

            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_address' | translate }}</th>
                <td mat-cell *matCellDef="let item">{{ formatAddress(item) }}</td>
            </ng-container>

            <ng-container matColumnDef="alertType">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_alert_type' | translate }}</th>
                <td mat-cell *matCellDef="let item">
                    <span class="alert-chip" [attr.data-type]="item.alert.alertType">
                        {{ item.alert.alertType }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="alertDate">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_alert_date' | translate }}</th>
                <td mat-cell *matCellDef="let item">{{ item.alert.alertDate | date:'medium' }}</td>
            </ng-container>

            <ng-container matColumnDef="notified">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_notified' | translate }}</th>
                <td mat-cell *matCellDef="let item">
                    {{ (item.alert.userNotified ? 'meter.manage.yes' : 'meter.manage.no') | translate }}
                </td>
            </ng-container>

            <ng-container matColumnDef="resolved">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_resolved' | translate }}</th>
                <td mat-cell *matCellDef="let item">
                    {{ (item.alert.resolved ? 'meter.manage.yes' : 'meter.manage.no') | translate }}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div *ngIf="!loading && alerts.length === 0" class="no-results">
            <p>{{ 'meter.manage.no_alerts' | translate }}</p>
        </div>
    </div>

    <mat-paginator
        [length]="total"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[10, 20, 50]"
        (page)="onPageChange($event)"
        showFirstLastButtons>
    </mat-paginator>
</div>
